"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var NoOptionMessage = function NoOptionMessage(props) {
  // eslint-disable-next-line react/prop-types
  var innerProps = props.innerProps,
      children = props.children;
  return _react["default"].createElement(_MenuItem["default"], (0, _extends2["default"])({
    disabled: true,
    component: "div"
  }, innerProps, {
    height: 35
  }), _react["default"].createElement(_Typography["default"], (0, _extends2["default"])({
    noWrap: true
  }, innerProps, {
    variant: "body1"
  }), children));
};

var _default = NoOptionMessage;
exports["default"] = _default;